import { render, staticRenderFns } from "./ButtonIconSimple.vue?vue&type=template&id=76f766ab&scoped=true"
import script from "./ButtonIconSimple.vue?vue&type=script&lang=ts"
export * from "./ButtonIconSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f766ab",
  null
  
)

export default component.exports